<template>
  <v-row>
    <v-col cols="7">
      <v-text-field
        v-bind="commonProps"
        filled
        type="text"
        @change="change"
        @input="pushUpdate"
        @click:append="getOnyx"
      >
        <template #prepend>
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn :disabled="!validIsbn" text icon class="ma-0" v-on="on" @click="getOnyx">
                <v-icon :color="validIsbn ? 'blue' : 'gray'">mdi-clipboard-arrow-down</v-icon>
              </v-btn>
            </template>
            Download Onyx Metadata for given ISBN
          </v-tooltip>
        </template>
      </v-text-field>
    </v-col>
    <v-col cols="5">
      <div class="upload-container">
        <v-file-input v-model="file" accept="text/xml" rounded small-chips label="Parse File" class="file-input">
        </v-file-input>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn :disabled="file === null" text class="upload-btn" @click="parseOnyx" v-on="on">
              <v-icon :color="file === null ? 'gray' : 'blue'">mdi-inbox-arrow-down</v-icon>
            </v-btn>
          </template>
          Parse selected ONYX file
        </v-tooltip>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Input from '@ilteducation/vuetify-admin/src/mixins/input';
import Editable from '@ilteducation/vuetify-admin/src/mixins/editable';
import { getMetadata, getParsedMetadata } from '@/data-provider/refDataProvider';

export default {
  mixins: [Input, Editable],
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isbn: '',
      validIsbn: true,
      file: null,
    };
  },
  mounted() {
    this.pushUpdate(this.input);
  },
  methods: {
    getOnyx() {
      console.log(`Update value ONYX ${this.isbn}`);
      this.$emit('fetchingMetadata');
      getMetadata(this.$store, this.isbn)
        .then((metadata) => {
          this.$emit('metadataFetched', metadata);
        })
        .catch((error) => {
          console.log(`failed to get metadata: ${error}`);
        })
        .finally(() => {
          this.$emit('metadataFetched');
        });
    },
    parseOnyx() {
      console.log(`Parse ONYX`);
      this.$emit('fetchingMetadata');
      if (this.file === null) {
        return;
      }
      this.$emit('fetchingMetadata');
      this.file
        ?.text()
        .then((toParse) => getParsedMetadata(this.$store, toParse, 'onix'))
        .then((metadata) => {
          this.$emit('metadataFetched', metadata);
        })
        .catch((error) => {
          console.log(`failed to get metadata: ${error}`);
        })
        .finally(() => {
          this.file = null;
          this.$emit('metadataFetched');
        });
    },
    pushUpdate(val) {
      const strVal = `${val}`;
      console.log(`push update ${strVal}`);
      this.isbn = strVal;
      if (strVal.length >= 13) {
        this.validIsbn = true;
      } else {
        this.validIsbn = false;
      }
      this.update(strVal);
    },
    getIcon() {
      if (this.props.value.length() >= 8) {
        return 'mdi-clipboard-arrow-down';
      }
      return 'mdi-clipboard-alert';
    },
  },
};
</script>

<style scoped>
.upload-container {
  display: flex;
  width: 100%;
}
.file-input {
  padding-right: 10px;
  background: white;
  border: 1px dashed #808080;
  border-radius: 1rem;
  height: 55px;
  flex-grow: 1;
}
.upload-btn {
  width: 20px;
  margin-left: -20px;
  margin-top: 11px;
  padding: 4px;
}
</style>
